import { FC } from 'react'
import { PageBackLink, PageTitle } from 'src/components/PageBackLink'
import { AD_ANALYSIS_LIBRARY_ROUTE } from 'src/constants/routes'
import classes from '../adLibrary.module.scss'

interface AdLibraryBreadcrumbProps {
  currentPage?: string
}

// "← Ad Analysis / Ad Library" on the list; on an advertiser page the
// advertiser's header carries the name, so only "← Ad Library" sits above it.
export const AdLibraryBreadcrumb: FC<AdLibraryBreadcrumbProps> = ({
  currentPage,
}) => (
  <div className={classes.heading}>
    {currentPage ? (
      <PageBackLink label="Ad Library" to={AD_ANALYSIS_LIBRARY_ROUTE} />
    ) : (
      <>
        <PageBackLink label="Ad Analysis" />
        <PageTitle>Ad Library</PageTitle>
      </>
    )}
  </div>
)
